import type { PagesState } from '@webapp/account/src/resources/pages/pages';

import type { Page } from '../common';
import { EMPTY_PAGE_ID } from '../questions';
import type { States } from '../states';

export const pages = ({ Pages }: States): PagesState => Pages;

export const selectPages = (states: States): Array<Page> => {
    const p = pages(states);

    return p.pages;
};

export const selectPageById =
    (pageId: number) =>
    (states: States): Page => {
        if (pageId === EMPTY_PAGE_ID) return null;

        const p = selectPages(states);

        return p.find(({ id }) => id === pageId);
    };

export const selectActivePageId = (states: States): number => {
    const s = pages(states);

    return s.activePageId;
};

export const selectPagesFetch = (states: States): boolean => {
    const p = pages(states);

    return p.fetch;
};

export const selectNoPages = (states: States): boolean => {
    const p = selectPages(states);
    const f = selectPagesFetch(states);

    return p.length === 0 && !f;
};
